export default __webpack_public_path__ + "static/media/compass.1846a28f.jpg";